import { render, staticRenderFns } from "./afiliados-regulamento-modal.vue?vue&type=template&id=64ebccec"
import script from "./afiliados-regulamento-modal.vue?vue&type=script&lang=js"
export * from "./afiliados-regulamento-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports